/**
 * HelloWorld 组件 — 演示组件注册
 *
 * 一个简单的 React 组件，展示如何作为注册组件被其他模块引用。
 */
import * as React from 'react';
/**
 * HelloWorld 页面组件
 */
export function HelloWorldComponent(_props) {
    const [count, setCount] = React.useState(0);
    return React.createElement('div', { className: 'helloworld-container' }, React.createElement('h1', null, 'Hello World'), React.createElement('p', null, `Count: ${count}`), React.createElement('button', { onClick: () => setCount(c => c + 1) }, 'Click me'));
}
//# sourceMappingURL=hello-world.js.map